// A scale row with no title, no description text and no image. The rich-text editor leaves
// markup such as "<p><br></p>" behind when emptied, so the description is read as text.
const isBlankScale = (scale) => {
  const text = (value) => String(value || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
  return !text(scale?.title) && !text(scale?.description) && !scale?.image_url?.desktop && !scale?.image_url?.mobile;
};

export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },

    header: {
      primary_heading: data?.header?.primary_heading || "",
      secondary_heading: data?.header?.secondary_heading || "",
      description: data?.header?.description || "",
      user_images: data?.header?.user_images?.length ? data.header.user_images : [{ image_url: "", alt_tag: "" }],
      primary_cta: data?.header?.primary_cta || { label: "", redirect_link: "" },
      secondary_cta: data?.header?.secondary_cta || { label: "", redirect_link: "" },
      banner_image: data?.header?.banner_image || { desktop: "", mobile: "", alt_tag: "" },
    },

    section_scale: {
      heading: data?.section_scale?.heading || "",
      description: data?.section_scale?.description || "",
      scales: data?.section_scale?.scales?.length
        ? data.section_scale.scales
        : [
            {
              title: "",
              alt_tag: "",
              description: "",
              image_url: { mobile: "", desktop: "" },
            },
          ],
    },

    section_trainers: {
      title: data?.section_trainers?.title || "",
      cta: data?.section_trainers?.cta || { label: "", redirect_link: "" },

      multi_title: data?.section_trainers?.multi_title?.length
        ? data.section_trainers.multi_title
        : [
            {
              title: "",
            },
          ],

      trainers: data?.section_trainers?.trainers?.length
        ? data.section_trainers.trainers
        : [
            {
              count: "",
              title: "",
              suffix: "",
            },
          ],
    },

    section_knowledge: {
      primary_heading: data?.section_knowledge?.primary_heading || "",
      secondary_heading: data?.section_knowledge?.secondary_heading || "",
      description: data?.section_knowledge?.description || "",

      steps_section: data?.section_knowledge?.steps_section?.length
        ? data.section_knowledge.steps_section
        : [
            {
              title: "",
              description: "",
              steps: "",
              image: "",
              alt_tag: "",
            },
          ],
    },
    section_pricing_plans: {
      heading: data?.section_pricing_plans?.heading || "",
      description: data?.section_pricing_plans?.description || "",
    },
    section_tools: {
      heading: data?.section_tools?.heading || "",
      description: data?.section_tools?.description || "",
      tools: data?.section_tools?.tools?.length ? data.section_tools.tools : [{ image_url: "", alt_tag: "" }],
    },
    section_testimonials: {
      heading: data?.section_testimonials?.heading || "",
    },
    section_level_up: {
      title: data?.section_level_up?.title || "",
      description: data?.section_level_up?.description || "",
      cta: data?.section_level_up?.cta || { label: "", redirect_link: "" },
      level_up_information: {
        header_one: data?.section_level_up?.level_up_information?.header_one || "",
        header_two: data?.section_level_up?.level_up_information?.header_two || "",
        header_three: data?.section_level_up?.level_up_information?.header_three || "",
        level_ups:
          data?.section_level_up?.level_up_information?.level_ups?.length > 0
            ? data.section_level_up.level_up_information.level_ups
            : [{ basis: "", before: "", after: "" }],
      },
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },

    header: {
      primary_heading: values?.header?.primary_heading || "",
      secondary_heading: values?.header?.secondary_heading || "",
      description: values?.header?.description || "",
      user_images: values?.header?.user_images?.length ? values.header.user_images : [{ image_url: "", alt_tag: "" }],
      primary_cta: {
        label: values?.header?.primary_cta?.label || "",
        redirect_link: values?.header?.primary_cta?.redirect_link || "",
      },
      secondary_cta: {
        label: values?.header?.secondary_cta?.label || "",
        redirect_link: values?.header?.secondary_cta?.redirect_link || "",
      },
      banner_image: {
        desktop: values?.header?.banner_image?.desktop || "",
        mobile: values?.header?.banner_image?.mobile || "",
        alt_tag: values?.header?.banner_image?.alt_tag || "",
      },
    },
    section_scale: {
      heading: values?.section_scale?.heading || "",
      description: values?.section_scale?.description || "",
      // Only rows with something in them. Saving used to add a blank row whenever the list
      // was empty, and kept blank rows as they were, which showed on the homepage as an
      // empty step with nothing beside it.
      scales: (values?.section_scale?.scales || []).filter((scale) => !isBlankScale(scale)),
    },
    section_trainers: {
      title: values?.section_trainers?.title || "",
      cta: {
        label: values?.section_trainers?.cta?.label || "",
        redirect_link: values?.section_trainers?.cta?.redirect_link || "",
      },


       multi_title: values?.section_trainers?.multi_title?.length
        ? values.section_trainers.multi_title
        : [
            {
              title: "",
            },
          ],

      trainers: values?.section_trainers?.trainers?.length
        ? values.section_trainers.trainers
        : [
            {
              count: "",
              title: "",
              suffix: "",
            },
          ],
    },
    section_knowledge: {
      primary_heading: values?.section_knowledge?.primary_heading || "",
      secondary_heading: values?.section_knowledge?.secondary_heading || "",
      description: values?.section_knowledge?.description || "",

      steps_section: values?.section_knowledge?.steps_section?.length
        ? values.section_knowledge.steps_section
        : [
            {
              title: "",
              description: "",
              steps: "",
              image: "",
              alt_tag: "",
            },
          ],
    },
    section_pricing_plans: {
      heading: values?.section_pricing_plans?.heading || "",
      description: values?.section_pricing_plans?.description || "",
    },
    section_tools: {
      heading: values?.section_tools?.heading || "",
      description: values?.section_tools?.description || "",
      tools: values?.section_tools?.tools?.length ? values.section_tools.tools : [{ image_url: "", alt_tag: "" }],
    },
    section_testimonials: {
      heading: values?.section_testimonials?.heading || "",
    },

    section_level_up: {
      title: values?.section_level_up?.title || "",
      description: values?.section_level_up?.description || "",
      cta: {
        label: values?.section_level_up?.cta?.label || "",
        redirect_link: values?.section_level_up?.cta?.redirect_link || "",
      },
      level_up_information: {
        header_one: values?.section_level_up?.level_up_information?.header_one || "",
        header_two: values?.section_level_up?.level_up_information?.header_two || "",
        header_three: values?.section_level_up?.level_up_information?.header_three || "",
        level_ups:
          values?.section_level_up?.level_up_information?.level_ups?.length > 0
            ? values.section_level_up.level_up_information.level_ups
            : [{ basis: "", before: "", after: "" }],
      },
    },
  };
};
